import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { default as React } from 'react';
import FormInfo from './FormInfo';
import LanguageAdornment from './LanguageAdornment';
import { globalStyles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import { createLengthWarning, isRTL } from './utils/utils';

const styles = Object.assign({
    titledTextField: {
        marginTop: 0,
        marginBottom: '6px'
    }
}, globalStyles);


class TitledTextField extends React.Component {

    render() {

        const { classes, title, name, text, onEnter, onCtrlEnter, maxLength, error, multiline, actions, inlineLengthWarning,
            lang, onChange, helperText, adornment, margin, autoFocus, errorText, startAdornment, height, minLength, ariaLabel,
            required, inputRef, placeholder, type, autoComplete, dataTest, disabled, rows, showLang } = this.props;
        const rtl = lang ? isRTL(lang) : false;

        return (
            <React.Fragment>
                <TitledPanel
                    dataTest={dataTest + "-panel"}
                    title={title}
                    margin={margin}
                    height={height}
                    required={required}
                    actions={
                        actions
                    }>
                    <TextField className={classes.titledTextField}
                        FormHelperTextProps={{
                            "data-test": dataTest + "-helper-text"
                        }}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        required={required}
                        autoComplete={autoComplete}
                        variant="outlined"
                        margin="dense"
                        inputRef={inputRef}
                        id={name}
                        minRows={rows}
                        maxRows={rows}
                        multiline={multiline}
                        error={error}
                        name={name}
                        placeholder={placeholder || title}
                        type={type || "text"}
                        value={text}
                        fullWidth
                        onKeyPress={(ev) => {
                            if (!error && ev.charCode === 13) {
                                if (!multiline) {
                                    if (text.length >= minLength && onEnter) {
                                        ev.ctrlKey && onCtrlEnter ? onCtrlEnter() : onEnter();
                                    }
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                }
                            }
                        }}
                        onChange={onChange}
                        helperText={errorText ?
                            <span id={name + "-error"}>{errorText}</span>
                            :
                            inlineLengthWarning ?
                                createLengthWarning(text, maxLength)
                                :
                                null}
                        InputProps={{
                            className: classes.inputLabel,
                            autoComplete,
                            inputProps: {
                                "data-test": dataTest,
                                "aria-label": ariaLabel,
                                "aria-required": required,
                                ...(error) && {
                                    "aria-invalid": true,
                                    ...(errorText) && { "aria-describedby": name + "-error" },
                                },
                                maxLength: maxLength,
                                ...(rtl) && { dir: "rtl" },
                                "lang": lang
                            },
                            startAdornment: (lang && showLang ? <LanguageAdornment lang={lang} /> : startAdornment),
                            endAdornment: adornment
                        }} />
                </TitledPanel>
                {(helperText || (!inlineLengthWarning && createLengthWarning(text, maxLength)) || multiline) &&
                    <FormInfo>{helperText
                        || (multiline && text.length + " of " + this.props.maxLength + " characters.")
                        || createLengthWarning(text, maxLength)}</FormInfo>}
            </React.Fragment>
        );
    }
}

TitledTextField.defaultProps = {
    autoFocus: false,
    showLang: true,
    maxLength: 50,
    required: false,
    multiline: false,
    error: false,
    disabled: false,
    margin: false,
    minLength: 1,
    inlineLengthWarning: false,
    rows: 4
};

TitledTextField.propTypes = {
    dataTest: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    autoFocus: PropTypes.bool,
    actions: PropTypes.object,
    ariaLabel: PropTypes.string,
    autoComplete: PropTypes.string,
    required: PropTypes.bool,
    height: PropTypes.string,
    errorText: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    lang: PropTypes.string,
    inlineLengthWarning: PropTypes.bool,
    error: PropTypes.bool,
    margin: PropTypes.bool,
    adornment: PropTypes.object,
    startAdornment: PropTypes.object,
    multiline: PropTypes.bool,
    helperText: PropTypes.string,
    rows: PropTypes.number,
    onEnter: PropTypes.func,
    onCtrlEnter: PropTypes.func,
    minLength: PropTypes.number.isRequired,
    maxLength: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(TitledTextField);